import {
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
} from '@mui/material';
import { useAppState } from 'components/contexts/State';
import { useEffect, useState } from 'react';

const { ThemeProvider } = require('@emotion/react');
const { defaultTheme } = require('theme');

function DocumentDataStep({ open, onClose, onSave, initialData, isLoading }) {
  const [formData, setFormData] = useState({
    data_creation_date: '',
    document_title: '',
    public_link: '',
    data_refresh_date: '',
  });

  useEffect(() => {
    if (initialData) {
      setFormData(initialData);
    }
  }, [initialData]);

  const [errors, setErrors] = useState({
    dataCreationDate: '',
    documentTitle: '',
  });

  const validateFields = () => {
    const newErrors = {};
    if (!formData.data_creation_date) {
      newErrors.dataCreationDate = 'Document Title is required';
    }
    if (!formData.document_title) {
      newErrors.documentTitle = 'Document Title is required';
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleInputChange = (field) => (e) => {
    const value = e.target.value;

    setFormData((prevData) => ({
      ...prevData,
      [field]: value,
    }));
  };

  const handleSave = async () => {
    if (validateFields()) {
      await onSave(formData);
    }
  };
  const handleClose = () => {
    if (!isLoading) {
      onClose();
      setErrors({ dataCreationDate: '', documentTitle: '' });
      setFormData({
        data_creation_date: '',
        document_title: '',
        public_link: '',
        data_refresh_date: '',
      });
    }
  };

  const today = new Date().toISOString().split('T')[0];

  return (
    <ThemeProvider theme={defaultTheme}>
      <Dialog
        open={open}
        onClose={() => {}}
        sx={{
          '.MuiDialog-paper': {
            width: '600px',
            boxShadow:
              '0px 11px 15px -7px rgba(0, 0, 0, 0.2),0px 24px 38px 3px rgba(0, 0, 0, 0.14),0px 9px 46px 8px rgba(0, 0, 0, 0.12)',
          },
        }}
      >
        <DialogTitle
          className='text-heading-style-1'
          sx={{
            padding: '16px 24px',
            borderBottom: '1px solid rgba(0, 37, 71, 0.12)',
          }}
        >
          Add details
        </DialogTitle>
        <DialogContent sx={{ padding: '20px 24px !important' }}>
          <div
            style={{
              display: 'flex',
              width: '100%',
              flexDirection: 'column',
              gap: '24px',
            }}
          >
            <TextField
              fullWidth
              id='outlined'
              type='date'
              label='Data creation date'
              variant='outlined'
              required
              color='secondary'
              className='outlined-textfield-style-1'
              value={formData.data_creation_date}
              onChange={handleInputChange('data_creation_date')}
              error={!!errors.dataCreationDate}
              helperText={
                errors.dataCreationDate || 'The date your dataset was originally created'
              }
              InputLabelProps={{
                shrink: true,
              }}
              InputProps={{
                sx: {
                  '& input::-webkit-calendar-picker-indicator': {
                    filter:
                      'invert(48%) sepia(12%) saturate(478%) hue-rotate(174deg) brightness(89%) contrast(85%)',
                    opacity: 1,
                    width: '18px',
                    height: '20px',
                    cursor: 'pointer',
                  },
                },
              }}
              inputProps={{
                max: today,
              }}
              FormHelperTextProps={{
                sx: { color: '#00254799' },
              }}
            />
            <TextField
              label='Document title'
              type='text'
              fullWidth
              required
              variant='outlined'
              color='secondary'
              className='outlined-textfield-style-1'
              value={formData.document_title}
              onChange={handleInputChange('document_title')}
              error={!!errors.documentTitle}
              helperText={errors.documentTitle}
              InputLabelProps={{
                shrink: formData.document_title ? true : undefined,
              }}
            />

            <TextField
              label='Public Link (optional)'
              type='text'
              fullWidth
              variant='outlined'
              color='secondary'
              className='outlined-textfield-style-1'
              onChange={handleInputChange('public_link')}
              value={formData.public_link}
              helperText={
                'A public website URL for this document is highly recommended (for use in prompt answers).'
              }
              InputLabelProps={{
                shrink: formData.public_link ? true : undefined,
              }}
            />

            <TextField
              fullWidth
              id='outlined'
              type='date'
              label='Data refresh date (optional)'
              variant='outlined'
              color='secondary'
              value={formData.data_refresh_date}
              onChange={handleInputChange('data_refresh_date')}
              className='outlined-textfield-style-1'
              helperText="You’ll get an 'Update your data' email reminder on this date."
              InputLabelProps={{
                shrink: true,
              }}
              InputProps={{
                sx: {
                  '& input::-webkit-calendar-picker-indicator': {
                    filter:
                      'invert(48%) sepia(12%) saturate(478%) hue-rotate(174deg) brightness(89%) contrast(85%)',
                    opacity: 1,
                    width: '18px',
                    height: '20px',
                    cursor: 'pointer',
                  },
                },
              }}
              inputProps={{
                min: today,
              }}
              FormHelperTextProps={{
                sx: { color: '#00254799' },
              }}
            />
          </div>
        </DialogContent>
        <DialogActions sx={{ padding: '16px 24px' }}>
          <Button
            className='primary-text-button-medium'
            onClick={handleClose}
            disabled={isLoading}
          >
            Cancel
          </Button>
          <Button
            variant='contained'
            className='primary-contained-button-medium'
            onClick={handleSave}
            disabled={isLoading}
            endIcon={isLoading ? <CircularProgress size={12} /> : null}
          >
            Save
          </Button>
        </DialogActions>
      </Dialog>
    </ThemeProvider>
  );
}

export default DocumentDataStep;
